let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8dSCv")).then(() => parcelRequire('aX5Qn'));